module.exports = {
    "isAnimation": true,
    "isLoop": true,
    "frames": [
        {
            "time": 0,
            "image": require("./jasmine_run_0000.png").default
        },
        {
            "time": 100,
            "image": require("./jasmine_run_0100.png").default
        },
        {
            "time": 200,
            "image": require("./jasmine_run_0200.png").default
        },
        {
            "time": 300,
            "image": require("./jasmine_run_0300.png").default
        },
        {
            "time": 400,
            "image": require("./jasmine_run_0400.png").default
        },
    ]
}
